import BaseUrlDetector from './base-url__detector';
import BaseUrlValidator from './base-url__validator';
import BaseUrlHelper from './base-url__helper';
import UrlHelper from '../url-helper/url-helper';
import Confirm from '@jetbrains/ring-ui/components/confirm-ng/confirm-ng';

import '../resource/resource';

export default angular.module('installer.base-url', ['installer.resource', Confirm, UrlHelper.name]).
  service('baseUrlDetector', BaseUrlDetector).
  service('baseUrlValidator', BaseUrlValidator).
  service('baseUrlHelper', BaseUrlHelper);



// WEBPACK FOOTER //
// ./src/blocks/base-url/base-url.js